(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var initializeCarousel = function(root) {
      if (!root || root.dataset.carouselReady === 'true') return;

      var scroller = root.querySelector('.featured-collection__overflow');
      var previousButton = root.querySelector('.featured-collection__previous');
      var nextButton = root.querySelector('.featured-collection__next');
      if (!scroller || !previousButton || !nextButton) return;

      root.dataset.carouselReady = 'true';

      var updateButtons = function() {
        var maximumScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        var hasMore = maximumScroll > 3;
        previousButton.classList.toggle('is-hidden', !hasMore || scroller.scrollLeft <= 3);
        nextButton.classList.toggle('is-hidden', !hasMore || scroller.scrollLeft >= maximumScroll - 3);
      };

      scroller.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      requestAnimationFrame(updateButtons);
    };

    var initializeAllCarousels = function(scope) {
      scope.querySelectorAll('[data-featured-collection-carousel]').forEach(initializeCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initializeAllCarousels(document);
      });
    } else {
      initializeAllCarousels(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
      initializeAllCarousels(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
